<template>
  <div>
    <div id="body">
      <!-- <div
        :class="showIsHover ? 'top-filter-tabs is-hover' : 'top-filter-tabs'"
      >
        <div class="wrapper">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="国内宏观数据" name="2"></el-tab-pane>
            <el-tab-pane label="国内产量数据" name="1"></el-tab-pane>
            <el-tab-pane label="进出口数据" name="3"></el-tab-pane>
          </el-tabs>
        </div>
      </div> -->
      <div class="banner">
        <div class="wrapper">
          <div class="title">
            <h1 v-if="activeTab === '2'">国内宏观数据</h1>
            <h1 v-if="activeTab === '1'">国内产量数据</h1>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="search-filter">
          <el-row>
            <el-col :xs="24"
                    :sm="7">
              <el-form label-width="5.0em"
                       size="small">
                <el-form-item label="地区：">
                  <!-- <el-input
                    v-model="selectRegion"
                    placeholder="全国"
                    disabled
                  ></el-input> -->
                  <el-input v-model="selectRegion"
                            placeholder="全国"
                            readonly></el-input>
                </el-form-item>

                <el-form-item label="类型："
                              v-if="activeTab === '3'">
                  <el-radio-group v-model="jckType">
                    <el-radio label="jinkou">进口</el-radio>
                    <el-radio label="chukou">出口</el-radio>
                    <el-radio label="jinchukou">进出口</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="币制："
                              v-if="activeTab === '3'">
                  <el-radio-group v-model="jckMoney">
                    <el-radio label="rmb">人民币</el-radio>
                    <el-radio label="usd">美元</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="商品名：" v-if="activeTab === '3'">
                  <el-input
                    v-model="jckGoodsName"
                    placeholder="请输入商品名称"
                  ></el-input>
                </el-form-item> -->
                <el-form-item :label="activeTab !== '3' ? '指标：' : '商品名：'">
                  <el-select v-model="cnames"
                             multiple
                             filterable
                             remote
                             reserve-keyword
                             placeholder="请输入关键词"
                             :remote-method="
                      activeTab !== '3'
                        ? regionDataNameRemote
                        : jinchukouDataNameRemote
                    "
                             :loading="cnameLoading"
                             :multiple-limit="5"
                             popper-class="cnames-width">
                    <template v-if="activeTab !== '3'">
                      <el-option v-for="item in regionDataNameOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </template>
                    <template v-else>
                      <el-option v-for="item in jinchukouDataNameOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>

                <el-form-item label="日期："
                              v-if="activeTab !== '2'">
                  <el-date-picker v-model="selectDate"
                                  type="monthrange"
                                  range-separator="至"
                                  start-placeholder="开始月份"
                                  end-placeholder="结束月份"
                                  style="width: 316.5px"
                                  format="yyyy年MM月">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="年份："
                              v-if="activeTab === '2'">
                  <el-date-picker v-model="selectStartYear"
                                  type="year"
                                  placeholder="开始年"
                                  format="yyyy年"
                                  style="width: 138px">
                  </el-date-picker>
                  <span style="padding: 0 13px">至</span>
                  <el-date-picker v-model="selectEndYear"
                                  type="year"
                                  placeholder="结束年"
                                  format="yyyy年"
                                  style="width: 138px">
                  </el-date-picker>
                </el-form-item>
                <el-form-item class="submit"
                              label="">
                  <el-button type="primary"
                             @click="handleSearch">
                    检索
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :xs="24"
                    :sm="17">
              <div class="map">
                <div v-loading="loading"
                     id="geoMap"
                     style="width: 100%; height: 100%"></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="search-top"
             v-if="showTable">
          <div class="search-top-time">
            <!-- <el-form size="small" inline>
              <el-form-item>
                <div slot="label">日期</div>
                <el-select
                  v-model="searchSort"
                  size="small"
                  @change="handleSortChange"
                >
                  <el-option :value="0" label="时间"></el-option>
                  <el-option :value="1" label="相关度"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleInstitutionSearch"
                  >检索</el-button
                >
              </el-form-item>
            </el-form> -->
            <el-tabs v-model="activeCName"
                     @tab-click="handleRegionDataTabClick">
              <el-tab-pane v-for="cname in cnameTabs"
                           :label="cname"
                           :name="cname"
                           :key="cname">
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="search-display">
            <el-button size="mini"
                       type=""
                       @click="handleExport"
                       v-if="showTable && tableData && tableData.length > 0">
              <svg t="1655450861977"
                   class="icon"
                   viewBox="0 0 1024 1024"
                   version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="6279"
                   width="200"
                   height="200">
                <path d="M409.12 877.74H239.83c-51.27 0-92.98-41.71-92.98-93V239.29c0-51.27 41.71-92.98 92.98-92.98h545.45c51.29 0 93 41.71 93 92.98v169.29c0 20.2-16.38 36.57-36.57 36.57-20.2 0-36.57-16.38-36.57-36.57V239.29c0-10.95-8.91-19.84-19.86-19.84H239.83c-10.95 0-19.84 8.89-19.84 19.84v545.45c0 10.95 8.89 19.86 19.84 19.86h169.29c20.2 0 36.57 16.38 36.57 36.57s-16.37 36.57-36.57 36.57z"
                      p-id="6280"></path>
                <path d="M821.37 718.72H527.19c-20.2 0-36.57-16.38-36.57-36.57 0-20.2 16.38-36.57 36.57-36.57h294.18c20.2 0 36.57 16.38 36.57 36.57 0 20.2-16.37 36.57-36.57 36.57z"
                      p-id="6281"></path>
                <path d="M718.58 841.83c-9.36 0-18.71-3.57-25.86-10.71-14.29-14.29-14.29-37.45 0-51.71l97.25-97.25-97.25-97.25c-14.29-14.27-14.29-37.43 0-51.71 14.29-14.29 37.43-14.29 51.71 0l123.12 123.11a36.565 36.565 0 0 1 10.71 25.86c0 9.7-3.86 19-10.71 25.86L744.44 831.11c-7.14 7.15-16.5 10.72-25.86 10.72z"
                      p-id="6282"></path>
              </svg>
              导出
            </el-button>
            <!-- <el-radio-group v-model="dataType" size="small">
              <el-radio-button label="报表"></el-radio-button>
              <el-radio-button label="图形"></el-radio-button>
            </el-radio-group> -->
          </div>
        </div>
        <div class="search-result-list">
          <div class="table-list"
               v-loading="tableLoading"
               v-if="tableData && tableData.length > 0">
            <div>
              <span v-html="tableTitle"></span>
            </div>
            <!-- <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="region" label="地区" width="150">
              </el-table-column>
              <el-table-column label="时间">
                <el-table-column
                  v-for="item in yearCodeList"
                  :key="item.value"
                  :prop="item.value"
                  :label="item.label"
                ></el-table-column>
              </el-table-column>
            </el-table> -->

            <el-table :data="tableData"
                      style="width: 100%"
                      v-if="activeTab === '1'">
              <el-table-column prop="date"
                               label="日期"></el-table-column>
              <el-table-column prop="dyzStrdata"
                               :label="'当月值' + (dyzUnit ? '（' + dyzUnit + '）' : '')">
              </el-table-column>
              <el-table-column prop="ljzStrdata"
                               :label="'累计值' + (ljzUnit ? '（' + ljzUnit + '）' : '')">
              </el-table-column>
              <el-table-column prop="tbzzStrdata"
                               :label="'同比增长' + (tbzzUnit ? '（' + tbzzUnit + '）' : '')">
              </el-table-column>
              <el-table-column prop="ljzzStrdata"
                               :label="'累计增长' + (ljzzUnit ? '（' + ljzzUnit + '）' : '')">
              </el-table-column>
            </el-table>

            <el-table :data="tableData"
                      style="width: 100%"
                      v-if="activeTab === '2'">
              <el-table-column prop="date"
                               label="时间"></el-table-column>
              <!-- <el-table-column
                v-for="cname in cnameTableHead"
                :key="cname"
                :prop="cname"
                :label="cname"
              >
              </el-table-column> -->
              <el-table-column v-for="item in cnameTableHeadUnit"
                               :key="item.cname"
                               :prop="item.cname"
                               :label="item.cname + (item.unit ? '（' + item.unit + '）' : '')">
              </el-table-column>
            </el-table>

            <el-table :data="tableData"
                      style="width: 100%"
                      v-if="activeTab === '3'">
              <el-table-column prop="month"
                               label="日期"
                               width="100"></el-table-column>
              <el-table-column prop="goodsName"
                               label="商品名称"></el-table-column>
              <el-table-column prop="businessPartnerName"
                               label="贸易伙伴"
                               width="150"></el-table-column>
              <el-table-column prop="registrationRegionName"
                               label="注册地"
                               width="150"></el-table-column>
              <el-table-column prop="tradeModeName"
                               label="贸易方式"></el-table-column>
              <el-table-column label="第一数量">
                <template #default="scope">
                  {{ scope.row.firstCount }}
                  {{
                    scope.row.firstCountUnit
                      ? "（" + scope.row.firstCountUnit + "）"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column label="第二数量">
                <template #default="scope">
                  {{ scope.row.secondCount }}
                  {{
                    scope.row.secondCountUnit
                      ? "（" + scope.row.secondCountUnit + "）"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column label="金额">
                <template #default="scope">
                  {{
                    scope.row.money && scope.row.money === "rmb"
                      ? "￥"
                      : scope.row.money && scope.row.money === "usd"
                      ? "$"
                      : ""
                  }}
                  {{ scope.row.amount }}
                </template>
              </el-table-column>
            </el-table>

            <!-- <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="date" label="日期" width="180">
              </el-table-column>
              <el-table-column prop="name" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="address" label="地址"> </el-table-column>
            </el-table> -->
          </div>
          <div class="no-data"
               v-if="showTable && (!tableData || tableData.length === 0)">
            <div class="tip">
              <svg t="1626241932884"
                   class="icon"
                   viewBox="0 0 1428 1024"
                   version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="2321"
                   width="60"
                   height="60">
                <path d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                      p-id="2322"></path>
                <path d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                      p-id="2323"></path>
                <path d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                      p-id="2324"></path>
                <path d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                      p-id="2325"></path>
                <path d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                      p-id="2326"></path>
                <path d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                      p-id="2327"></path>
              </svg>
              <div class="text">暂无数据</div>
            </div>
          </div>
          <!-- 找到
          <span>{{ total > 10000 ? "10000+" : total }}</span>
          条结果 -->
          <!-- （用时0.03秒） -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";
import cnAreaMap from "@/assets/geoMap/geo/cnArea.js";
import * as echarts from "echarts";
import * as d3 from "d3-geo";
import $ from "jquery";
import { exportTongjiDownload } from "../../util/utils";

let areaPosArr = [
  { name: "北京市", top: 250, left: 550 },
  { name: "黑龙江省", top: 130, left: 700 },
  { name: "吉林省", top: 190, left: 670 },
  { name: "辽宁省", top: 225, left: 640 },
  { name: "河北省", top: 233, left: 565 },
  { name: "天津市", top: 267, left: 562 },
  { name: "山东省", top: 320, left: 570 },
  { name: "江苏省", top: 370, left: 595 },
  { name: "上海市", top: 396, left: 615 },
  { name: "浙江省", top: 420, left: 600 },
  { name: "福建省", top: 470, left: 570 },
  { name: "台湾省", top: 510, left: 605 },
  { name: "广东省", top: 500, left: 515 },
  { name: "江西省", top: 450, left: 535 },
  { name: "安徽省", top: 390, left: 560 },
  { name: "海南省", top: 565, left: 465 },
  { name: "广西壮族自治区", top: 505, left: 455 },
  { name: "湖南省", top: 445, left: 490 },
  { name: "湖北省", top: 395, left: 495 },
  { name: "河南省", top: 355, left: 505 },
  { name: "山西省", top: 300, left: 495 },
  { name: "陕西省", top: 350, left: 450 },
  { name: "重庆市", top: 410, left: 440 },
  { name: "贵州省", top: 460, left: 430 },
  { name: "云南省", top: 490, left: 360 },
  { name: "四川省", top: 410, left: 375 },
  { name: "甘肃省", top: 285, left: 370 },
  { name: "宁夏回族自治区", top: 295, left: 420 },
  { name: "内蒙古自治区", top: 220, left: 500 },
  { name: "青海省", top: 320, left: 290 },
  { name: "西藏自治区", top: 390, left: 190 },
  { name: "新疆维吾尔自治区", top: 250, left: 150 },
];

let areaPosObj = {
  北京市: { name: "北京市", top: 250, left: 550 },
  黑龙江省: { name: "黑龙江省", top: 130, left: 700 },
  吉林省: { name: "吉林省", top: 190, left: 670 },
  辽宁省: { name: "辽宁省", top: 225, left: 640 },
  河北省: { name: "河北省", top: 233, left: 565 },
  天津市: { name: "天津市", top: 267, left: 562 },
  山东省: { name: "山东省", top: 320, left: 570 },
  江苏省: { name: "江苏省", top: 370, left: 595 },
  上海市: { name: "上海市", top: 396, left: 615 },
  浙江省: { name: "浙江省", top: 420, left: 600 },
  福建省: { name: "福建省", top: 470, left: 570 },
  台湾省: { name: "台湾省", top: 510, left: 605 },
  广东省: { name: "广东省", top: 500, left: 515 },
  江西省: { name: "江西省", top: 450, left: 535 },
  安徽省: { name: "安徽省", top: 390, left: 560 },
  海南省: { name: "海南省", top: 565, left: 465 },
  广西壮族自治区: { name: "广西壮族自治区", top: 505, left: 455 },
  湖南省: { name: "湖南省", top: 445, left: 490 },
  湖北省: { name: "湖北省", top: 395, left: 495 },
  河南省: { name: "河南省", top: 355, left: 505 },
  山西省: { name: "山西省", top: 300, left: 495 },
  陕西省: { name: "陕西省", top: 350, left: 450 },
  重庆市: { name: "重庆市", top: 410, left: 440 },
  贵州省: { name: "贵州省", top: 460, left: 430 },
  云南省: { name: "云南省", top: 490, left: 360 },
  四川省: { name: "四川省", top: 410, left: 375 },
  甘肃省: { name: "甘肃省", top: 285, left: 370 },
  宁夏回族自治区: { name: "宁夏回族自治区", top: 295, left: 420 },
  内蒙古自治区: { name: "内蒙古自治区", top: 220, left: 500 },
  青海省: { name: "青海省", top: 320, left: 290 },
  西藏自治区: { name: "西藏自治区", top: 390, left: 190 },
  新疆维吾尔自治区: { name: "新疆维吾尔自治区", top: 250, left: 150 },
};

export default {
  components: {},
  data () {
    return {
      tableData: [],
      loading: false,
      hideTimer: null,
      provinceShowIng: null,
      activeTab: this.$route.query.filterTab || "2",
      selectRegion: "",
      cnames: [],
      cnameLoading: false,
      regionDataNameOptions: [
        { label: "地区生产总值", value: "地区生产总值" },
        { label: "人均地区生产总值", value: "人均地区生产总值" },
        { label: "人口出生率", value: "人口出生率" },
        { label: "人口死亡率", value: "人口死亡率" },
        { label: "发电量", value: "发电量" },
        { label: "电力消费量", value: "电力消费量" },
        { label: "农林牧渔业增加值", value: "农林牧渔业增加值" },
        { label: "工业增加值", value: "工业增加值" },
        { label: "建筑业增加值", value: "建筑业增加值" },
        { label: "批发和零售业增加值", value: "批发和零售业增加值" },
      ],
      selectDate: [],
      dataType: 0,
      total: 0,
      pageCount: 0,
      cnameTabs: [],
      activeCName: "",
      oldActiveCName: "",
      pageIndex: 1,
      yearCodeList: [],
      tableTitle: "",
      tableLoading: false,
      selectStartYear: null,
      selectEndYear: null,
      cnameTableHead: [],
      cnameTableHeadUnit: [],
      dyzUnit: "",
      ljzUnit: "",
      tbzzUnit: "",
      ljzzUnit: "",
      showTable: false,
      jckType: "jinkou",
      jckMoney: "rmb",
      jckGoodsName: "",
      jinchukouDataNameOptions: [],
      showIsHover: false,
    };
  },
  created () {
    this.handleTabClick();
  },
  watch: {
    "$route.query" (newQuery) {
      this.activeTab = newQuery.filterTab || "2";
      this.handleTabClick();
    },
  },
  mounted () {
    this.initMap();
  },
  methods: {
    handleExport () {
      this.exportRegionDataTable();
    },
    exportRegionDataTable () {
      let startYearCode = "",
        endYearCode = "",
        text = "";
      if (this.activeTab === "1") {
        text = this.activeCName;
        if (this.selectDate && this.selectDate.length > 0) {
          startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
        }
        if (this.selectDate && this.selectDate.length > 1) {
          endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
        }
      } else if (this.activeTab === "2") {
        this.cnames.forEach((cname) => {
          if (text) {
            text += ";";
          }
          text += cname;
        });
        if (this.selectStartYear) {
          startYearCode = this.dateFormat(this.selectStartYear, "yyyy") + "00";
        }
        if (this.selectEndYear) {
          endYearCode = this.dateFormat(this.selectEndYear, "yyyy") + "00";
        }
      }

      let url = `${process.env.VUE_APP_BASE_API}/search/export-region-data-table`;
      let data = `text=${text}&region=${this.selectRegion || "全国"
        }&startYearCode=${startYearCode}&endYearCode=${endYearCode}&type=${this.activeTab
        }`;

      this.handleExportDownload(url, data);
    },
    handleExportDownload (url, data) {
      exportTongjiDownload(url, this.activeCName, data);
    },
    regionDataNameRemote (query) {
      if (query) {
        this.regionDataNameOptions = [];
        axiosRequest(
          "/search/region-data-name-match",
          { text: query, type: this.activeTab },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data.code === 200) {
              if (
                res.data.data.cname_count &&
                res.data.data.cname_count.length > 0
              ) {
                const list = [];
                res.data.data.cname_count.forEach((item) => {
                  list.push({ value: item.key, label: item.key });
                });
                this.regionDataNameOptions = list;
              }
            }
          })
          .catch(() => { });
      }
    },
    handleSearch () {
      if (!this.cnames || this.cnames.length === 0) {
        this.$message({ message: "请选择指标！", type: "warning" });
        return;
      }

      if (this.activeTab === "2") {
        this.cnameTabs = ["国内宏观数据"];
      } else {
        this.cnameTabs = this.cnames;
      }
      this.activeCName = this.cnameTabs[0];
      this.oldActiveCName = this.activeCName;

      this.pageIndex = 1;
      this.tableData = [];
      this.regionDataTableMatch();
    },
    handleNextPage () {
      if (this.pageIndex < this.pageCount) {
        this.pageIndex++;

        this.regionDataTableMatch();
      }
    },
    regionDataTableMatch () {
      this.tableLoading = true;
      let startYearCode = "",
        endYearCode = "",
        text = "";
      if (this.activeTab === "1") {
        text = this.activeCName;
        if (this.selectDate && this.selectDate.length > 0) {
          startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
        }
        if (this.selectDate && this.selectDate.length > 1) {
          endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
        }
      } else if (this.activeTab === "2") {
        this.cnames.forEach((cname) => {
          if (text) {
            text += ";";
          }
          text += cname;
        });
        if (this.selectStartYear) {
          startYearCode = this.dateFormat(this.selectStartYear, "yyyy") + "00";
        }
        if (this.selectEndYear) {
          endYearCode = this.dateFormat(this.selectEndYear, "yyyy") + "00";
        }
      }

      this.showTable = true;

      axiosRequest(
        "/search/region-data-table-match",
        {
          text: text,
          region: this.selectRegion || "全国",
          startYearCode: startYearCode,
          endYearCode: endYearCode,
          //type: this.activeTab === "first" ? 1 : 0,
          type: this.activeTab,
          pageIndex: this.pageIndex,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data.code === 200) {
            if (this.activeTab === "1") {
              let dyzData = res.data.data["当月值"];
              let ljzData = res.data.data["累计值"];
              let tbzzData = res.data.data["同比增长"];
              let ljzzData = res.data.data["累计增长"];

              let yearCodeArray = [];
              if (dyzData && dyzData.length > 0) {
                yearCodeArray = dyzData.map((item) => {
                  if (item.yearCode && item.yearCode.length === 4) {
                    return item.yearCode + "00";
                  }
                  return item.yearCode;
                });
              } else if (ljzData && ljzData.length > 0) {
                yearCodeArray = ljzData.map((item) => {
                  if (item.yearCode && item.yearCode.length === 4) {
                    return item.yearCode + "00";
                  }
                  return item.yearCode;
                });
              } else if (tbzzData && tbzzData.length > 0) {
                yearCodeArray = tbzzData.map((item) => {
                  if (item.yearCode && item.yearCode.length === 4) {
                    return item.yearCode + "00";
                  }
                  return item.yearCode;
                });
              } else if (ljzzData && ljzzData.length > 0) {
                yearCodeArray = ljzzData.map((item) => {
                  if (item.yearCode && item.yearCode.length === 4) {
                    return item.yearCode + "00";
                  }
                  return item.yearCode;
                });
              }

              let dyzUnit = "",
                ljzUnit = "",
                tbzzUnit = "",
                ljzzUnit = "";

              yearCodeArray.forEach((yearCode) => {
                let dyzItem = dyzData.find(
                  (item) => item.yearCode === yearCode
                );
                if (dyzItem && !dyzUnit) {
                  dyzUnit = dyzItem.unit;
                }

                let ljzItem = ljzData.find(
                  (item) => item.yearCode === yearCode
                );
                if (ljzItem && !ljzUnit) {
                  ljzUnit = ljzItem.unit;
                }

                let tbzzItem = tbzzData.find(
                  (item) => item.yearCode === yearCode
                );
                if (tbzzItem && !tbzzUnit) {
                  tbzzUnit = tbzzItem.unit;
                }

                let ljzzItem = ljzzData.find(
                  (item) => item.yearCode === yearCode
                );
                if (ljzzItem && !ljzzUnit) {
                  ljzzUnit = ljzzItem.unit;
                }

                let year = yearCode.substring(0, 4);
                let month = yearCode.substring(4);
                let dateStr = year + "年";
                if (month && month !== "00") {
                  dateStr += month + "月";
                }

                let obj = new Object();
                obj["date"] = dateStr;
                obj["dyzStrdata"] = dyzItem ? dyzItem.strdata : "-";
                obj["ljzStrdata"] = ljzItem ? ljzItem.strdata : "-";
                obj["tbzzStrdata"] = tbzzItem ? tbzzItem.strdata : "-";
                obj["ljzzStrdata"] = ljzzItem ? ljzzItem.strdata : "-";

                this.tableData.push(obj);
              });

              this.dyzUnit = dyzUnit;
              this.ljzUnit = ljzUnit;
              this.tbzzUnit = tbzzUnit;
              this.ljzzUnit = ljzzUnit;
            } else if (this.activeTab === "2") {
              let yearCodeArray = res.data.data.records.map((item) => {
                if (item.yearCode && item.yearCode.length === 4) {
                  return item.yearCode + "00";
                }
                return item.yearCode;
              });
              yearCodeArray = Array.from(new Set(yearCodeArray));

              let cnameArray = res.data.data.records.map((item) => item.cname);
              this.cnameTableHead = Array.from(new Set(cnameArray));
              this.cnameTableHeadUnit = [];
              yearCodeArray.forEach((yearCode) => {
                let year = yearCode.substring(0, 4);
                let month = yearCode.substring(4);
                let dateStr = year + "年";
                if (month && month !== "00") {
                  dateStr += month + "月";
                }

                let obj = new Object();
                obj["date"] = dateStr;

                this.cnameTableHead.forEach((cname) => {
                  let findItem = res.data.data.records.find(
                    (item) => item.yearCode === yearCode && item.cname === cname
                  );
                  if (!findItem) {
                    findItem = res.data.data.records.find(
                      (item) =>
                        item.yearCode + "00" === yearCode &&
                        item.cname === cname
                    );
                  }
                  obj[cname] = findItem ? findItem.strdata : "-";
                  if (findItem && findItem.unit) {
                    let unitIndex = this.cnameTableHeadUnit.findIndex(
                      (item) => item.cname === cname
                    );
                    if (unitIndex < 0) {
                      this.cnameTableHeadUnit.push({
                        cname: cname,
                        unit: findItem.unit,
                      });
                    }
                  }
                });

                this.tableData.push(obj);
              });
            }
          }

          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleTabClick (val) {
      if (this.activeTab === "3") {
        this.$router.push("/tongji/jinchukou");
      } else {
        this.showIsHover = !this.showIsHover;
        this.regionDataNameOptions = [];
        if (this.activeTab === "2") {
          //国内宏观数据
          this.regionDataNameOptions = [
            { label: "地区生产总值", value: "地区生产总值" },
            { label: "人均地区生产总值", value: "人均地区生产总值" },
            { label: "人口出生率", value: "人口出生率" },
            { label: "人口死亡率", value: "人口死亡率" },
            { label: "发电量", value: "发电量" },
            { label: "电力消费量", value: "电力消费量" },
            { label: "农林牧渔业增加值", value: "农林牧渔业增加值" },
            { label: "工业增加值", value: "工业增加值" },
            { label: "建筑业增加值", value: "建筑业增加值" },
            { label: "批发和零售业增加值", value: "批发和零售业增加值" },
          ];
        } else if (this.activeTab === "1") {
          //国内产量数据
          this.regionDataNameOptions = [
            { label: "原煤产量", value: "原煤产量" },
            { label: "核能发电量", value: "核能发电量" },
            { label: "焦炭产量", value: "焦炭产量" },
            { label: "汽油产量", value: "汽油产量" },
            { label: "煤层气产量", value: "煤层气产量" },
            { label: "风力发电量", value: "风力发电量" },
            { label: "煤气产量", value: "煤气产量" },
            { label: "液化天然气产量", value: "液化天然气产量" },
            { label: "煤油产量", value: "煤油产量" },
            { label: "液化石油气产量", value: "液化石油气产量" },
          ];
        }
        this.cnames = [];
        this.cnameTabs = [];
        this.tableData = [];
        this.showTable = false;
      }
    },
    handleRegionDataTabClick (val) {
      if (this.oldActiveCName !== val.name) {
        this.pageIndex = 1;
        this.tableData = [];
        this.oldActiveCName = val.name;

        if (this.activeTab === "3") {
          this.jinchukouDataTableMatch();
        } else {
          this.regionDataTableMatch();
        }
      }
    },

    initMap () {
      let geoMapChartDom = document.getElementById("geoMap");
      let geoMapChart = echarts.init(geoMapChartDom);
      // let _this = this;
      geoMapChart.on("click", (params) => {
        if (params.data) {
          // _this.toEntityMapPageByProvince(params.data.name);
        }
      });
      this.initGeoMap(geoMapChart);
    },
    initGeoMap (geoMapChart) {
      geoMapChart.showLoading();
      geoMapChart.on("mouseover", (params) => {
        // console.log("clickParams", params);
        let data = params.data;
        this.showMapTips(data);
      });
      geoMapChart.on("mouseout", (params) => {
        // console.log("clickParams", params);
        // $('.graph .map .tips').empty();
        this.hideTimer = setTimeout(this.hideMapTips, 2000);
        // hideMapTips();
      });
      geoMapChart.on("click", (params) => {
        let data = params.data;
        if (data && data.name) {
          if (data.name === this.selectRegion) {
            this.selectRegion = "";
          } else {
            this.selectRegion = data.name;
          }
        } else {
          this.selectRegion = "";
        }
      });
      this.drawMap(areaPosArr, geoMapChart, "中国");
    },
    //  geoMap.js
    showMapTipsByCircle (data, geoMapChart) {
      // selMap(data.name, geoMapChart,true);
      this.showMapTips(data, true);
    },
    hideMapTipsByCircle (data, geoMapChart) {
      // selMap(data.name, geoMapChart,false);
      this.hideTimer = setTimeout(this.hideMapTips, 2000);
    },
    //首页地图
    showMapTips (data, isCircle) {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }
      // console.log(this.provinceShowIng,data);
      // console.log(data);
      if (data) {
        let province = data.name;
        if (!isCircle) {
          if (this.provinceShowIng === province) {
            return false;
          }
        }
        let $mapTips = $(".graph .map .tips");
        if (!data) {
          $mapTips.append("<p>暂无统计数据</p>");
          return false;
        }
      }
    },
    hideMapTips () {
      let $mapTips = $(".top .map .tips");
      $mapTips.hide();
      // $mapTips.css({top:-150,left:-200});
    },
    drawMap (data, chart, key) {
      const cnJson = cnAreaMap[key];
      const projection = d3.geoMercator();
      chart.hideLoading();
      echarts.registerMap(key, cnJson);
      let option = {
        title: {
          text: "",
          subtext: "",
          sublink: "",
          left: "right",
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
        series: [
          {
            name: "中国",
            type: "map",
            map: key,
            projection: {
              project: (point) => {
                return projection(point);
              },
              unproject: (point) => {
                return projection.invert(point);
              },
            },
            itemStyle: {
              areaColor: "#dcf1ff",
              borderColor: "#bdc7db",
              borderWidth: 1.3,
            },
            emphasis: {
              label: {
                show: true,
              },
              itemStyle: {
                areaColor: "#9ed4ff",
              },
            },
            select: {
              label: {
                show: true,
                color: "#fff",
              },
              itemStyle: {
                areaColor: "#AC4A3B",
              },
            },
            data: data,
            zoom: 1.24,
            roam: false,
          },
        ],
      };
      chart.setOption(option);
    },
    dateFormat (cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },
  },
};
</script>

<style>
.cnames-width {
  width: 90%;
  max-width: 400px;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";

.table-list ::v-deep .el-table {
  td.el-table__cell,
  th.el-table__cell.is-leaf {
    border-left: 1px solid #ebeef5;
    text-align: center;
  }
}
.search-filter .el-date-editor ::v-deep .el-range-input {
  text-align: center;
}
#body {
  padding-top: 25px;

  ::v-deep .el-date-editor {
    .el-range__icon {
      margin-left: 5px;
      margin-top: 1px;
    }
    .el-range-separator {
      width: auto;
      line-height: 30px;
    }
  }
}
.map {
  height: 500px;
  @media screen and (max-width: 768px) {
    margin-top: 20px;
    height: calc(100vw - 60px);
  }
}
.search-filter {
  padding: 10px;
  @media screen and (max-width: 768px) {
    padding: 10px 15px;
    .el-date-editor {
      width: calc(100% / 2 - 20px) !important;
    }
    .el-range-editor {
      width: 100% !important;
    }
    .el-radio-group {
      width: 100%;
    }
  }
  ::v-deep {
    .el-form-item__content {
      padding-right: 0;
    }
  }
  .el-form {
    max-height: inherit;
  }
  .el-form-item {
    border: 0;
  }
  .el-select {
    width: 100%;
  }
  .submit {
    @media screen and (max-width: 768px) {
      margin-top: 10px;
      .el-button {
        width: 100%;
      }
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
    text-align: center;
    // .el-button {
    // }
  }
}
.search-top {
  height: 44px !important;
  ::v-deep {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__nav-wrap:after {
      display: none;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      font-size: 16px;
      line-height: 40px;
    }
  }
  .search-top-time {
    float: left;
  }
  .search-display {
    float: right;
    .el-button {
      padding: 5px 15px;
      background-color: transparent;
    }
    svg {
      width: 20px;
      height: 20px;
      vertical-align: -5px;
    }
  }
}
@media screen and (max-width: 768px) {
  .search-top-time {
    float: none !important;
  }
  .search-display {
    display: none;
  }
}
</style>